/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-formatting-rotate-clockwise-filled': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M17.5 18.75H10c-.69 0-1.25-.56-1.25-1.25V10c0-.69.56-1.25 1.25-1.25h7.5c.69 0 1.25.56 1.25 1.25v7.5c0 .69-.56 1.25-1.25 1.25zM9.375 1.25l-.881.881 1.612 1.619H6.875A4.38 4.38 0 002.5 8.125v3.125h1.25V8.125A3.129 3.129 0 016.875 5h3.231L8.494 6.619l.881.881L12.5 4.375 9.375 1.25z"/>'
  }
})
